var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.924,
    height: 45.924,
    viewBox: "0 0 45.924 45.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-553 -462)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(553 462)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.962,
    cy: 22.962,
    r: 22.962,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.962,
    cy: 22.962,
    r: 22.462,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(566 478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.878,17.574a3.1,3.1,0,1,1,3.1-3.1A3.1,3.1,0,0,1,12.878,17.574Zm0-4.716A1.621,1.621,0,1,0,14.5,14.479,1.621,1.621,0,0,0,12.878,12.858ZM17.3,18.789a.737.737,0,0,1-.519-1.256,4.327,4.327,0,0,0,0-6.108.737.737,0,1,1,1.043-1.038,5.8,5.8,0,0,1,0,8.183A.725.725,0,0,1,17.3,18.789Zm-8.843.006a.749.749,0,0,1-.525-.218,5.8,5.8,0,0,1,0-8.189.738.738,0,1,1,1.043,1.043,4.321,4.321,0,0,0,0,6.1.737.737,0,0,1,0,1.043A.749.749,0,0,1,8.457,18.795Z",
    transform: "translate(-2.693 -7.309)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.076,19.677a.737.737,0,0,1-.737-.737.766.766,0,0,1,.224-.536,8.118,8.118,0,0,0,0-11.791.738.738,0,0,1,1.026-1.061,9.586,9.586,0,0,1,0,13.889A.719.719,0,0,1,17.076,19.677Zm-13.335,0a.731.731,0,0,1-.59-.259A9.592,9.592,0,0,1,3.228,5.546.738.738,0,1,1,4.254,6.607a8.118,8.118,0,0,0,0,11.791.746.746,0,0,1-.513,1.279Z",
    transform: "translate(-0.223 -5.338)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveLeftIcon);
export default __webpack_public_path__ + "static/media/liveLeftIcon.1529f48f713a0e45b5e249882d8e6bf6.svg";
export { ForwardRef as ReactComponent };